import React, { useRef } from 'react';

import Main from './Main/Main'
import Subscribe from './Subscribe/Subscribe';
import Bottombar from '../../containers/Bottombar/Bottombar';

import firebase from 'firebase/app';
import 'firebase/firestore'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Promo from './Promo/Promo';
import { useHistory } from 'react-router-dom';

const Home = () => {

    const history = useHistory();
    const scrollToRef = useRef();

    const notifySubscribed = () => toast.success('Thanks for subscribing!', {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });;

    const notifyErrorSubscribed = () => toast.error('Subscribing allowed once every 5 minutes...', {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });;


    const handleOnSubscribe = (email) => {
        const lastTimeSubscribed = localStorage.getItem("lastEmailSubscribedTime");
        if (lastTimeSubscribed && new Date().getTime() - lastTimeSubscribed < 60 * 5 * 1000) {
            notifyErrorSubscribed();
            return;
        }

        const ref = firebase.firestore().collection("web").doc("emails");
        ref.update({
            emails: firebase.firestore.FieldValue.arrayUnion(email),
        });

        
        localStorage.setItem("lastEmailSubscribedTime" , new Date().getTime())
        notifySubscribed();
    }

    const handleGetStartedClick = () => {
        //history.push('/course')
        window.scrollTo(0, scrollToRef.current.offsetTop)
    }

    return (
        <>
            {/* <Topbar /> */}
            <Main onGetStartedClick={() => handleGetStartedClick()}/>
            <Promo scrollToRef={scrollToRef}/>
            <Subscribe subscribed={handleOnSubscribe} />
            <Bottombar onGetStartedClick={() => handleGetStartedClick()}/>
            <ToastContainer
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}
export default Home;